import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { ReactComponent as SendIcon } from '../../../../../assetsNew/icons/paper-airplane.svg';
import { ReactComponent as Loader } from '../../../../../assetsNew/progress-indicator.svg';
import { updateBatchMessageStatus } from '../../../../../sagas/batchMessage/actions';
import { getSendbirdBatchMessageInfoRequest } from '../../../../../sagas/sendbird/batchMessage/info/actions';

import './_pendingItem.scss';

const PendingItem = ({ item }) => {
  const dispatch = useDispatch();
  const metaDataInterval = useRef(null);
  const fetchInterval = useRef(null);

  useEffect(() => {
    startIntervalIfNeeded();

    return () => {
      clearMetaInterval();
      resetLoader();
    };
  }, []);

  useEffect(() => {
    startIntervalIfNeeded();
    return () => {
      resetLoader();
    };
  }, [item]);

  const startIntervalIfNeeded = () => {
    const messageInProgress = item.status === 'running' || item.status === 'pending';

    if (messageInProgress && !metaDataInterval.current) {
      metaDataInterval.current = setInterval(() => {
        fetchTaskInfo();
      }, 5000);
    } else if (!messageInProgress && metaDataInterval.current) {
      clearMetaInterval();
    }
  };

  const fetchTaskInfo = () => {
    dispatch(getSendbirdBatchMessageInfoRequest({
      id: item.id,
      onSuccess: data => {
        dispatch(updateBatchMessageStatus({
          id: data.task_id,
          status: data.status,
          failed_count: data.failed_count || data.failed_recipients.length || null
        }));
      }
    }));
  };

  const clearMetaInterval = () => {
    if (metaDataInterval.current) {
      clearInterval(metaDataInterval.current);
      metaDataInterval.current = null;
    }
  };

  const resetLoader = () => {
    clearInterval(fetchInterval.current);
  };

  return (
    <div className="pendingItem">
      <div className="pendingItem-status">
        <SendIcon />
        <p className="pendingItem-status__label">Message sending progress</p>
      </div>
      <div className="pendingItem-loader">
        <Loader />
      </div>
    </div>
  );
};

PendingItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.any,
    status: PropTypes.string
  })
};

export default PendingItem;
